var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
var DepartmentComponent = /** @class */ (function () {
    function DepartmentComponent(util, apiService) {
        this.util = util;
        this.apiService = apiService;
        this.obj_data_all = [];
        this.obj_data = {};
    }
    DepartmentComponent.prototype.ngOnInit = function () {
        var that = this;
        var table = $('#tData').DataTable({
            "aaSorting": [],
            'columnDefs': [
                {
                    'targets': 5,
                    'searchable': false,
                    'orderable': false,
                    "className": "text-center",
                    'render': function (data, type, full, meta) {
                        return '<i name="delete" class="fa fa-close" style="color: red; cursor: pointer " role="' + data + '"></i>';
                    }
                }
            ]
        });
        $('#tData tbody').on('click', 'tr', function () {
            that.InitEdit(table.row(this).data()[0]);
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            }
            else {
                table.$('tr.selected').removeClass('selected');
                $(this).addClass('selected');
            }
        });
        $('#tData tbody').on('click', 'i', function () {
            var r = confirm("ยืนยันลบข้อมูล : " + $(this).attr('role'));
            if (r == true) {
                that.Delete($(this).attr('role'));
            }
        });
    };
    DepartmentComponent.prototype.Search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var table, that, data, res, i, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.obj_data_all = {};
                        table = $('#tData').DataTable();
                        table.clear().draw();
                        that = this;
                        this.util.ShowWaiting(true);
                        data = {};
                        data["DEPARTMENT_CODE"] = $('#txtID').val();
                        data["DEPARTMENT_DESC"] = $('#txtDesc').val();
                        data["DEPARTMENT_DESC_EN"] = $('#txtDescEn').val();
                        data["STATUS"] = $('#ddlStatus').val();
                        return [4 /*yield*/, this.apiService.post('master', 'GetDepartMent', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                if (res.responseData.length > 0) {
                                    this.obj_data_all = res.responseData;
                                    for (i = 0; i < res.responseData.length; i++) {
                                        status = '';
                                        if (res.responseData[i].status == 1) {
                                            status = "ใช้งาน";
                                        }
                                        else {
                                            status = "ไม่ใช้งาน";
                                        }
                                        table.row.add([res.responseData[i].department_code,
                                            res.responseData[i].department_desc,
                                            res.responseData[i].status,
                                            this.util.DisPlayDate(res.responseData[i].update_date),
                                            res.responseData[i].update_user,
                                            res.responseData[i].department_code]).draw();
                                    }
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentComponent.prototype.Add = function () {
        this.ClearDlg();
        $("#txtMode").val('A');
        $('#txtDlgID').prop('disabled', false);
        $('#dlgData').modal({
            backdrop: 'static',
            keyboard: false
        });
    };
    DepartmentComponent.prototype.InitEdit = function (x) {
        this.obj_data = {};
        if (this.obj_data_all != null) {
            if (this.obj_data_all.length > 0) {
                for (var i = 0; i < this.obj_data_all.length; i++) {
                    if (x == this.obj_data_all[i].department_code) {
                        $('#txtDlgID').val(this.obj_data_all[i].department_code);
                        $('#txtDlgDesc').val(this.obj_data_all[i].department_desc);
                        $('#ddlDlgStatus').val(this.obj_data_all[i].status);
                        this.obj_data = this.obj_data_all[i];
                        break;
                    }
                }
            }
        }
    };
    DepartmentComponent.prototype.Edit = function () {
        $("#txtMode").val('E');
        $('#txtDlgID').prop('disabled', true);
        if ($('#txtDlgID').val() != '' && $('#txtDlgID').val() != null
            && $('#txtDlgID').val() != 'null') {
            $('#dlgData').modal({
                backdrop: 'static',
                keyboard: false
            });
        }
    };
    DepartmentComponent.prototype.ClearDlg = function () {
        $('#tData tbody tr.selected').removeClass('selected');
        this.obj_data = {};
        $('#txtDlgID').val('');
        $('#txtDlgDesc').val('');
        $('#txtDlgDescEn').val('');
        $('#ddlDlgStatus').val('1');
    };
    DepartmentComponent.prototype.Delete = function (x) {
        return __awaiter(this, void 0, void 0, function () {
            var that, data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        that = this;
                        data = {};
                        data["department_code"] = x;
                        return [4 /*yield*/, this.apiService.post('master', 'DeleteDepartment', data)];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.isSuccess) {
                                this.util.SuccessDialog('บันทึกสำเร็จ');
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            this.util.ErrorDialog('System Error');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DepartmentComponent.prototype.Save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.util.ValidateForm()) return [3 /*break*/, 2];
                        data = {};
                        if ($("#txtMode").val() == 'A') {
                            data["DEPARTMENT_CODE"] = $('#txtDlgID').val();
                            data["DEPARTMENT_DESC"] = $('#txtDlgDesc').val();
                            data["STATUS"] = $('#ddlDlgStatus').val();
                            data["CREATE_USER"] = this.util.GetUserID();
                            data["UPDATE_USER"] = this.util.GetUserID();
                        }
                        else {
                            data = this.obj_data;
                            data["DEPARTMENT_DESC"] = $('#txtDlgDesc').val();
                            data["STATUS"] = $('#ddlDlgStatus').val();
                            data["UPDATE_USER"] = this.util.GetUserID();
                        }
                        return [4 /*yield*/, this.apiService.post('master', 'InsertUpdateDepartMent', data, $("#txtMode").val())];
                    case 1:
                        res = _a.sent();
                        if (res != null) {
                            if (res.isSuccess) {
                                this.util.SuccessDialog('บันทึกสำเร็จ');
                                $('#dlgData').modal('hide');
                                this.ClearDlg();
                                this.Search();
                            }
                            else {
                                this.util.ErrorDialog(res.errorCode + '-' + res.errorMessage);
                            }
                        }
                        else {
                            this.util.ErrorDialog('System Error');
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return DepartmentComponent;
}());
export { DepartmentComponent };



// WEBPACK FOOTER //
// ./src/app/member/department/department.component.ts.pre-build-optimizer.js